import { render } from "./PaginateLink.vue?vue&type=template&id=0f6f001a"
import script from "./PaginateLink.vue?vue&type=script&lang=js"
export * from "./PaginateLink.vue?vue&type=script&lang=js"
script.render = render

export default script